import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const addDigitalTwinEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_DIGITAL_TWIN();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error posting data: ${error.message}`);
  }
};
export const updateDigitalTwinEndpoint = async (data, digitalTwinId) => {
  const endpoint = API_ENDPOINTS.UPDATE_DIGITAL_TWIN(digitalTwinId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating digitalTwin: ${error.message}`);
  }
};

export const deleteDigitalTwinEndpoint = async digitalTwinId => {
  const endpoint = API_ENDPOINTS.DELETE_DIGITAL_TWIN(digitalTwinId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};
